/*
 * Module for a dynamic form which is to be notified when a field changes so 
 *  that it can notify dependent fields of that change.
*/
rs.module("controls/forms/dynamicform",

    [],

    function () {

        var _formInstances = {};

        //
        // Initialize
        //
        function initialize(formIdentifier, formFieldPrefix, factoryFormIdentifier, fieldDependents, backendUrls, httpHeaders) {

            var formInstance = {
                formIdentifier: formIdentifier,
                factoryFormIdentifier: factoryFormIdentifier,
                fieldDependents: fieldDependents,
                backendUrls: backendUrls,
                httpHeaderNames: httpHeaders,
                stateChangeHandlers: [],
                formFieldPrefix: formFieldPrefix
            }

            _formInstances[formIdentifier] = formInstance;
        }

        ///
        /// Gets a form instance by its identifier
        /// 
        function getForm(formIdentifier) {
            var instance = _formInstances[formIdentifier];

            return _createInstanceApi(instance);
        }

        ///
        ///  Creates a wrapper around a single instance and its state 
        // 
        function _createInstanceApi(instance) {

            // Create an empty object that we'll populate with the public interface
            var instanceApi = {};

            // Notify that a field has changed
            instanceApi.fieldChanged = function (fieldId, newValue) {

                var dependents = instance.fieldDependents[fieldId];
                if (dependents && Array.isArray(dependents)) {

                    var changedFieldName = _getFieldName(fieldId);

                    // update the state of each dependent control, if there's a state change handler
                    dependents.forEach(dependentField => {
                        var handler = instance.stateChangeHandlers.find(handler => handler.fieldId == dependentField);
                        if (handler) {
                            _updateFieldState(handler, [{ [changedFieldName]: newValue }]);
                        }
                    })
                }
            }

            //
            // Register a new state changed handler for the field represented by fieldId.
            //
            instanceApi.onFieldStateChanged = function (fieldId, currentValueFunc, newStateCallback) {
                instance.stateChangeHandlers.push(
                    {
                        fieldId: fieldId,
                        currentValueFunc: currentValueFunc,
                        newStateCallback: newStateCallback
                    });
            };

            //
            // Gets the field name for field identified by fieldId
            //
            function _getFieldName(fieldId) {
                // Not all fields have Ids
                if (fieldId) {
                    var fieldName = $.js(fieldId).attr("name");

                    return fieldName;
                }

                return undefined;
            }

            //
            // Update the state of the field represented by the handler passed in 
            //
            function _updateFieldState(
                handler,
                dependentFieldValues,
                ) {

                var requestData = {

                    // The backend needs to know which form this is for
                    form: instance.factoryFormIdentifier,

                    // We want to gert the new state for the field identified by the handler's fieldId
                    field: handler.fieldId,

                    // send the handler's current field value, using the html form field name so the value is automatically picked up during model binding
                    [_ajaxName(_getFieldName(handler.fieldId))]: handler.currentValueFunc()
                };

                // Copy dependent field values into the request data, again by html form field name so they get handled by model binding
                dependentFieldValues.forEach(field => {
                    for (const fieldName in field) {
                        requestData[_ajaxName(fieldName)] = field[fieldName];
                    }
                });

                return $.get({
                        url: instance.backendUrls.getFieldState,
                        data: requestData,
                        headers: { [instance.httpHeaderNames.getFieldState]: "true" }
                    })
                    .done(handler.newStateCallback);
            }

            function _ajaxName(fieldName) {

                // Trim the formFieldPrefix off of fieldName if it's there
                if (instance.formFieldPrefix) {
                    if (fieldName.startsWith(instance.formFieldPrefix)) {
                        fieldName = fieldName.substring(instance.formFieldPrefix.length);

                        // strip off a leading field separator if it exists
                        if (fieldName.startsWith('.')) {
                            fieldName = fieldName.substring(1);
                        }
                    }
                }

                // replace the first segment of the field name, which contains the _form_ name, with "form" since
                // that is what the backend binds to
                return fieldName.replace(/^[^.]+\./, "form.");
            }

            return instanceApi;
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            getForm: getForm
        };

        return exports;
    }
);